"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @class Form
 * @description the outer form component with serialization/validation hooks
 */
var PropTypes = require("prop-types");
var React = require("react");
var util_1 = require("../../utils/util");
var types_1 = require("./types");
var index_1 = require("../../index");
/**
 * Provide context with the legacy context api so as not to break downstreams.
 *
 * @deprecated Remove at next major version bump: https://jira.oci.oraclecorp.com/browse/UIPLAT-1620
 */
var LegacyFormContextProvider = /** @class */ (function (_super) {
    __extends(LegacyFormContextProvider, _super);
    function LegacyFormContextProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegacyFormContextProvider.prototype.getChildContext = function () {
        return { form: this.props.form };
    };
    LegacyFormContextProvider.prototype.render = function () {
        return this.props.children;
    };
    LegacyFormContextProvider.childContextTypes = { form: PropTypes.object };
    return LegacyFormContextProvider;
}(React.Component));
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.getInitState();
        _this.onChange = _this.onChange.bind(_this);
        _this.submitForm = _this.submitForm.bind(_this);
        _this.resetForm = _this.resetForm.bind(_this);
        _this.setValue = _this.setValue.bind(_this);
        // this allows consuming classes to get at methods in the form, such as resetForm()
        props.formRef && props.formRef(_this);
        return _this;
    }
    Form.prototype.ariaLiveFormErrors = function () {
        var _a = this.state, errors = _a.errors, submittedWithErrors = _a.submittedWithErrors;
        var errorKeys = Object.keys(errors);
        var focusItem = function (name) {
            var input = document.querySelector("[name=" + name + "]");
            input && input.focus();
        };
        var focusButton = function (id) {
            var handleClick = function () { return focusItem(id); };
            return React.createElement(index_1.Button, { type: index_1.ButtonType.Button, onClick: handleClick }, id);
        };
        return (React.createElement("div", { "aria-live": "polite", "aria-atomic": "true", "aria-relevant": "all", className: "hidden-offscreen" }, submittedWithErrors && (React.createElement(React.Fragment, null,
            React.createElement("p", null, "You have form errors"),
            React.createElement("ul", null, errorKeys.map(function (e) { return (React.createElement("li", { key: e },
                "Field with name ",
                focusButton(e),
                " has error message: ",
                errors[e],
                ".")); }))))));
    };
    Form.prototype.render = function () {
        var _a = this.props, children = _a.children, testId = _a.testId;
        return (React.createElement(types_1.FormContextProvider, { value: { form: this } },
            React.createElement(LegacyFormContextProvider, { form: this },
                React.createElement("form", { className: "oui-form", onSubmit: this.submitForm, "data-test-id": testId },
                    children,
                    this.ariaLiveFormErrors()))));
    };
    Form.prototype.componentWillReceiveProps = function (nextProps) {
        var defaultValues = this.props.defaultValues;
        var nextPropValueKeys = Object.keys(nextProps.defaultValues || {});
        var currentPropValueKeys = Object.keys(defaultValues || {});
        var notMatchingValues = nextPropValueKeys.some(function (key) {
            var currentDefault = defaultValues[key];
            var nextDefault = nextProps.defaultValues[key];
            // RichSelect supports multiple values, so do a shallow check
            if (Array.isArray(currentDefault) && Array.isArray(nextDefault)) {
                return !util_1.arraysAreEqual(nextDefault, currentDefault);
            }
            return nextDefault !== currentDefault;
        });
        // If default values were updated then override the pre-existing ones.
        if (notMatchingValues ||
            nextPropValueKeys.length > currentPropValueKeys.length) {
            // preserve values entered that are not defined by defaultValues
            var values = __assign({}, this.state.values, util_1.shallowClone(nextProps.defaultValues));
            this.setFormState({ values: values }, false);
        }
        // If a new loadState function was passed then call it.
        if (nextProps.loadState !== this.props.loadState && nextProps.loadState) {
            nextProps.loadState(this.props, this);
        }
    };
    Form.prototype.getInitState = function () {
        var _a = this.props, _b = _a.defaultValues, defaultValues = _b === void 0 ? {} : _b, loadState = _a.loadState;
        // preserve any subForms in the case this is being called by resetForm()
        var subForms = this.state ? this.state.subForms : {};
        var subFormValues = this.state ? this.state.subFormValues : {};
        var subFormState = this.state ? this.state.subFormState : {};
        if (loadState === undefined) {
            return {
                subForms: subForms,
                subFormValues: subFormValues,
                subFormState: subFormState,
                errors: {},
                isDirty: false,
                nestedErrors: {},
                values: util_1.shallowClone(defaultValues),
                touched: {},
                submittedWithErrors: false
            };
        }
        return loadState(__assign({}, this.props, { defaultValues: util_1.shallowClone(defaultValues) }), this);
    };
    Form.prototype.componentWillMount = function () {
        this.onChange();
    };
    Form.prototype.getValues = function () {
        return this.state.values;
    };
    Form.prototype.isValid = function () {
        var _this = this;
        return (Object.keys(this.state.errors).length === 0 &&
            Object.keys(this.state.subForms).every(function (key) {
                return _this.state.subForms[key].isValid();
            }));
    };
    Form.prototype.setFormState = function (newState, silent) {
        var _this = this;
        if (silent === void 0) { silent = false; }
        var _a = this.props, preValidate = _a.preValidate, saveState = _a.saveState;
        if (newState && newState.values && !newState.errors) {
            if (preValidate !== undefined) {
                newState.values = preValidate(newState.values, this);
            }
            newState.errors = this.validate();
        }
        this.setState(function (state) { return (__assign({}, state, newState)); }, function () {
            if (saveState !== undefined) {
                saveState(_this.state, _this.props, _this);
            }
            if (!silent) {
                _this.onChange();
            }
        });
    };
    Form.prototype.onChange = function () {
        if (this.props.onChange !== undefined) {
            this.props.onChange(this);
        }
    };
    Form.prototype.validate = function () {
        var validator = this.props.validator;
        if (!validator) {
            return {};
        }
        var result = validator(this.getValues(), this);
        Object.keys(result).forEach(function (key) {
            if (result[key] === undefined || result[key] === null) {
                delete result[key];
            }
        });
        return result;
    };
    Form.prototype.validateSubForms = function () {
        var subForms = this.state.subForms;
        var subFormErrors = Object.keys(subForms).reduce(function (acc, subFormKey) {
            var _a;
            var subFormErrors = subForms[subFormKey].triggerValidation();
            var newErrors = subFormErrors && Object.keys(subFormErrors).length > 0
                ? (_a = {}, _a[subFormKey] = subFormErrors, _a) : {};
            return __assign({}, acc, newErrors);
        }, {});
        return subFormErrors;
    };
    Form.prototype.triggerValidation = function () {
        var onValidationFail = this.props.onValidationFail;
        var errors = this.validate();
        var subFormErrors = this.validateSubForms();
        if (errors && Object.keys(errors).length > 0) {
            this.setFormState({ errors: errors, isDirty: true }, false);
        }
        var mergedErrors = __assign({}, subFormErrors, errors);
        if (mergedErrors && Object.keys(mergedErrors).length > 0) {
            onValidationFail && onValidationFail(this);
        }
        return mergedErrors;
    };
    Form.prototype.setAllValues = function (values, preserveTouchedStates) {
        if (preserveTouchedStates) {
            return this.setFormState({ values: values }, false);
        }
        this.setFormState({ values: values, touched: {} }, false);
    };
    Form.prototype.setValue = function (field, value, preserveTouchedState) {
        var values = util_1.deepSet(this.state.values, field, value);
        if (!preserveTouchedState) {
            util_1.deepSet(this.state.touched, field, true);
        }
        this.setFormState({ values: values }, preserveTouchedState);
    };
    Form.prototype.getValue = function (field, fallback) {
        if (fallback === void 0) { fallback = undefined; }
        var state = this.state;
        var val = util_1.deepGet(state.values, field, fallback);
        return val === undefined ? fallback : val;
    };
    Form.prototype.setNestedError = function (field, value) {
        var nestedErrors = util_1.deepSet(this.state.nestedErrors, field, value === false ? false : true);
        this.setFormState({ nestedErrors: nestedErrors }, false);
    };
    Form.prototype.getError = function (field) {
        return util_1.deepGet(this.state.errors, field);
    };
    Form.prototype.setTouched = function (field, value) {
        var touched = util_1.deepSet(this.state.touched, field, value === false ? false : true);
        this.setFormState({ touched: touched }, false);
    };
    Form.prototype.getTouched = function (field) {
        if (this.state.isDirty === true || this.props.isTouched === true) {
            return true;
        }
        return util_1.deepGet(this.state.touched, field);
    };
    Form.prototype.addValue = function (field, value) {
        var values = util_1.deepSet(this.state.values, field, __spread(util_1.deepGet(this.state.values, field, []), [
            value
        ]));
        this.setFormState({ values: values });
    };
    Form.prototype.removeValue = function (field, index) {
        var state = this.state;
        var fieldValue = util_1.deepGet(state.values, field, []);
        var values = util_1.deepSet(state.values, field, __spread(fieldValue.slice(0, index), fieldValue.slice(index + 1)));
        this.setFormState({ values: values }, false);
    };
    Form.prototype.setAllTouched = function () {
        this.setFormState({ isDirty: true }, false);
    };
    Form.prototype.resetForm = function () {
        return this.setFormState(this.getInitState(), false);
    };
    Form.prototype.submitForm = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var firstField, _a, preSubmit, onSubmit, postSubmit, mergedErrors, mergedErrorKeys, subFormKeys, firstFieldElement, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        // e won't exist if submitForm is invoked manually.
                        if (e) {
                            e.preventDefault();
                        }
                        _a = this.props, preSubmit = _a.preSubmit, onSubmit = _a.onSubmit, postSubmit = _a.postSubmit;
                        mergedErrors = this.triggerValidation();
                        mergedErrorKeys = Object.keys(mergedErrors);
                        // if we found errors in this form or any of the sub-forms, we want to short-circuit the submit
                        // the errors will be displayed in the sub-form due to triggerValidation being called
                        if (mergedErrors && mergedErrorKeys.length > 0) {
                            this.setFormState({ submittedWithErrors: true }, true);
                            // set focus to first field with an error
                            try {
                                firstField = mergedErrorKeys[0];
                                if (typeof mergedErrors[firstField] !== "string") {
                                    subFormKeys = Object.keys(mergedErrors[firstField]);
                                    firstField = subFormKeys[0];
                                }
                                firstFieldElement = document.getElementById(firstField);
                                firstFieldElement && firstFieldElement.focus();
                            }
                            catch (e) {
                                console.warn("Can not find element", firstField, mergedErrors);
                            }
                            return [2 /*return*/];
                        }
                        // If we passed validation, and we are ready to submit, clear the touched flag to allow
                        // component internal validation to clear (e.g. DropFileSelector)
                        this.setFormState({ touched: {}, submittedWithErrors: false }, false);
                        _b = preSubmit;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, preSubmit(this)];
                    case 1:
                        _b = (_e.sent());
                        _e.label = 2;
                    case 2:
                        _b;
                        _c = onSubmit;
                        if (!_c) return [3 /*break*/, 4];
                        return [4 /*yield*/, onSubmit(this)];
                    case 3:
                        _c = (_e.sent());
                        _e.label = 4;
                    case 4:
                        _c;
                        // TODO reset all touched when submit works
                        this.setFormState({ isDirty: false }, false);
                        _d = postSubmit;
                        if (!_d) return [3 /*break*/, 6];
                        return [4 /*yield*/, postSubmit(this)];
                    case 5:
                        _d = (_e.sent());
                        _e.label = 6;
                    case 6:
                        _d;
                        return [2 /*return*/];
                }
            });
        });
    };
    Form.prototype.getPreviousSubformState = function (fieldName) {
        var mountedSubform = this.state.subForms[fieldName];
        // If subform is still mounted, read from there instead of subFormValues store
        return mountedSubform ? mountedSubform.getValues() : this.state.subFormValues[fieldName];
    };
    Form.prototype.getCachedSubformState = function (fieldName) {
        var mountedSubform = this.state.subForms[fieldName];
        return mountedSubform ? mountedSubform.state : this.state.subFormState[fieldName];
    };
    Form.prototype.mountSubForm = function (subForm, fieldName) {
        this.setState(function (state) {
            var _a;
            return ({
                subForms: __assign({}, state.subForms, (_a = {}, _a[fieldName] = subForm, _a))
            });
        });
    };
    Form.prototype.unmountSubForm = function (subForm, fieldName) {
        var formValues = subForm.getValues();
        // set state with the saved values, but not the subForm ref itself
        this.setState(function (state) {
            var _a, _b;
            return ({
                subFormValues: __assign({}, state.subFormValues, (_a = {}, _a[fieldName] = formValues, _a)),
                subFormState: __assign({}, state.subFormState, (_b = {}, _b[fieldName] = subForm.state, _b)),
                subForms: Object.keys(state.subForms).reduce(function (acc, key) {
                    if (key !== fieldName) {
                        acc[key] = state.subForms[key];
                    }
                    return acc;
                }, {})
            });
        });
    };
    return Form;
}(React.Component));
exports.Form = Form;
exports.default = Form;
//# sourceMappingURL=Form.js.map